import { MemberSubscriptionStatus } from '@vista-digital/ocapi-types/v1';
import { CardExpirationStatus, getCardExpirationStatus } from '../../../utils/get-card-expiration-status';
import { MemberPaymentCardWalletNotificationType } from '../subcomponents/notification';
export const getMemberPaymentCardWalletNotificationType = (subscriptionDetails, primaryCard, expiringSoonThresholdInMonths) => {
    var _a;
    const cardExpirationStatus = primaryCard && getCardExpirationStatus(primaryCard.cardDetails, expiringSoonThresholdInMonths);
    const hasValidPrimaryCard = !!cardExpirationStatus && cardExpirationStatus !== CardExpirationStatus.Expired;
    switch (subscriptionDetails === null || subscriptionDetails === void 0 ? void 0 : subscriptionDetails.status) {
        case MemberSubscriptionStatus.Frozen: {
            if (!hasValidPrimaryCard)
                return MemberPaymentCardWalletNotificationType.FrozenDueToExpiredPrimary;
            return MemberPaymentCardWalletNotificationType.FrozenDueToFailedPayments;
        }
        case MemberSubscriptionStatus.Active: {
            if (!!((_a = subscriptionDetails === null || subscriptionDetails === void 0 ? void 0 : subscriptionDetails.billingDetails.billingError) === null || _a === void 0 ? void 0 : _a.willBeRetried)) {
                if (!hasValidPrimaryCard) {
                    return MemberPaymentCardWalletNotificationType.FailedLastPaymentDueToExpiredPrimary;
                }
                return MemberPaymentCardWalletNotificationType.FailedLastPayment;
            }
            if (subscriptionDetails.billingDetails.isUsingThirdPartyPaymentProvider) {
                if (hasValidPrimaryCard) {
                    return MemberPaymentCardWalletNotificationType.UnableToChangePaymentProviderToVista;
                }
                return MemberPaymentCardWalletNotificationType.ThirdPartyPaymentProviderPhasingOut;
            }
            if (cardExpirationStatus === CardExpirationStatus.Expired) {
                return MemberPaymentCardWalletNotificationType.ExpiredPrimaryCardWarning;
            }
            if (cardExpirationStatus === CardExpirationStatus.ExpiringSoon) {
                return MemberPaymentCardWalletNotificationType.ExpiringPrimaryCardWarning;
            }
            return;
        }
        default:
    }
};
